<div class="flex min-h-screen bg-brand-light font-sans">

  <aside class="w-64 bg-[#5b21b6] text-white flex flex-col shrink-0 fixed h-full z-10">
    <div class="p-6 flex items-center gap-3">
      <app-logo></app-logo>
    </div>

    <nav class="flex-1 px-4 space-y-2 mt-4">
      <a routerLink="/intake"
         class="flex items-center gap-3 px-4 py-3 bg-white text-brand-purple rounded-lg font-medium shadow-sm">
        <span class="material-icons text-xl">dashboard</span> Dashboard
      </a>
    </nav>

    <div class="p-4 border-t border-white/10 mt-auto">
      <button (click)="logout()"
              class="flex items-center gap-3 px-4 py-3 text-white/80 hover:bg-white/10 rounded-lg font-medium transition-colors w-full">
        <span class="material-icons text-xl">logout</span> Sign Out
      </button>
    </div>
  </aside>

  <main class="flex-1 p-8 ml-64 overflow-y-auto">

    <header class="flex justify-between items-center mb-8">
      <h1 class="text-2xl font-bold text-gray-900">Liife Intake Dashboard</h1>
      <div class="flex items-center gap-4">
        <button class="bg-brand-purple hover:bg-purple-700 text-white px-6 py-2.5 rounded-lg shadow-md flex items-center gap-2 font-medium transition-all"
                [routerLink]="['/add-user']">
          <span class="material-icons text-sm">add</span> Add Recipient
        </button>
        <app-user-profile-avatar></app-user-profile-avatar>
      </div>
    </header>

    @if (isLoading()) {
    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 mb-8">
      <nz-skeleton [nzActive]="true"
                   [nzParagraph]="{ rows: 4 }"></nz-skeleton>
    </div>
    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
      <nz-skeleton [nzActive]="true"
                   [nzParagraph]="{ rows: 10 }"></nz-skeleton>
    </div>
    }
    @else {
    <div class="grid grid-cols-4 gap-6 mb-8 bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
      <div class="flex flex-col">
        <span class="text-gray-800 font-semibold mb-1">Total Recipients</span>
        <div class="flex items-baseline gap-2">
          <span class="text-4xl font-bold text-gray-900">{{ stats().total.value }}</span>
        </div>
      </div>
      <div class="flex flex-col border-l pl-6">
        <span class="text-gray-800 font-semibold mb-1">Completed</span>
        <div class="flex items-baseline gap-2">
          <span class="text-4xl font-bold text-gray-900">{{ stats().completed.value }}</span>
        </div>
      </div>
      <div class="flex flex-col border-l pl-6">
        <span class="text-gray-800 font-semibold mb-1">In Progress</span>
        <div class="flex items-baseline gap-2">
          <span class="text-4xl font-bold text-gray-900">{{ stats().inProgress.value }}</span>
        </div>
      </div>
      <div class="flex flex-col border-l pl-6">
        <span class="text-gray-800 font-semibold mb-1">New Signups</span>
        <div class="flex items-baseline gap-2">
          <span class="text-4xl font-bold text-gray-900">{{ stats().newSignups.value }}</span>
        </div>
      </div>
    </div>

    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 mb-8">
      <h2 class="text-xl font-bold text-gray-900 mb-6">Redetermination Management</h2>

      <div class="flex flex-col md:flex-row gap-4 mb-6">
        <div class="flex-1 relative">
          <span class="material-icons absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400">search</span>
          <input type="text"
                 (input)="updateSearch($event)"
                 placeholder="Search by name, phone or email"
                 class="w-full border border-gray-200 rounded-lg pl-12 pr-4 py-3 focus:outline-none focus:ring-2 focus:ring-brand-purple/20 transition-all">
        </div>
        <button
                class="bg-brand-purple text-white px-8 py-3 rounded-lg font-medium shadow-sm hover:bg-purple-700 transition-colors">Search</button>
      </div>

      <div class="flex gap-4 mb-8">
        <button (click)="setFilter('All')"
                [ngClass]="activeFilter() === 'All' ? 'bg-brand-purple text-white border-brand-purple' : 'bg-white text-gray-600 border-gray-200'"
                class="flex-1 border py-2 rounded-lg font-medium text-sm transition-all shadow-sm">All</button>
        <button (click)="setFilter('New')"
                [ngClass]="activeFilter() === 'New' ? 'bg-brand-purple text-white border-brand-purple' : 'bg-white text-gray-600 border-gray-200'"
                class="flex-1 border py-2 rounded-lg font-medium text-sm transition-all shadow-sm">New</button>
        <button (click)="setFilter('In Progress')"
                [ngClass]="activeFilter() === 'In Progress' ? 'bg-brand-purple text-white border-brand-purple' : 'bg-white text-gray-600 border-gray-200'"
                class="flex-1 border py-2 rounded-lg font-medium text-sm transition-all shadow-sm">In Progress</button>
        <button (click)="setFilter('Completed')"
                [ngClass]="activeFilter() === 'Completed' ? 'bg-brand-purple text-white border-brand-purple' : 'bg-white text-gray-600 border-gray-200'"
                class="flex-1 border py-2 rounded-lg font-medium text-sm transition-all shadow-sm">Completed</button>
      </div>

      <div class="overflow-x-auto min-h-[400px]">
        <table class="w-full text-left">
          <thead>
            <tr class="text-gray-900 text-sm font-semibold border-b border-gray-100">
              <th class="pb-4 pl-2 flex items-center gap-1 cursor-pointer group">
                Recipient
                <span class="material-icons text-base text-gray-400">arrow_downward</span>
              </th>
              <th class="pb-4">Phone Number</th>
              <th class="pb-4">PE Application</th>
              @if (activeFilter() === 'Completed') {
              <th class="pb-4">PE Number</th>
              }
              <th class="pb-4">Zip Code</th>
              <th class="pb-4">Liife Id</th>
              @if (activeFilter() === 'Completed') {
              <th class="pb-4">Submission Date</th>
              <th class="pb-4">Coverage Period</th>
              }

              <th class="pb-4">Date Added</th>
              <th class="pb-4 text-right pr-2">Actions</th>
            </tr>
          </thead>
          <tbody class="text-sm">
            @for (user of paginatedRecipients(); track user.email) {
            <tr class="border-b border-gray-50 last:border-0 hover:bg-gray-50 transition-colors group">
              <td class="py-4 pl-2">
                <div class="flex items-center gap-3 cursor-pointer"
                     [routerLink]="['/intake/application', user.id]">
                  <div class="w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm"
                       [ngClass]="user.color">
                    {{ user.initials }}
                  </div>
                  <div>
                    <div class="font-bold text-gray-900">{{ user.name }}</div>
                    <div class="text-gray-400 text-xs">{{ user.email }}</div>
                  </div>
                </div>
              </td>
              <td class="py-4 text-gray-600 font-medium whitespace-nowrap cursor-pointer"
                  [routerLink]="['/intake/application', user.id]">{{ user.phone }}</td>
              <td class="py-4 cursor-pointer"
                  [routerLink]="['/intake/application', user.id]">
                <div class="flex items-center gap-1.5 font-medium whitespace-nowrap"
                     [ngClass]="user.liifeIdColor">
                  <span class="material-icons text-lg">{{ user.liifeIdIcon }}</span>
                  {{ user.liifeIdStatus }}
                </div>
              </td>
              @if (activeFilter() === 'Completed') {
              <td class="py-4 text-gray-600 cursor-pointer"
                  [routerLink]="['/intake/application', user.id]">{{ user.application?.peNumber ?? '-' }}</td>
              }
              <td class="py-4 text-gray-600 cursor-pointer"
                  [routerLink]="['/intake/application', user.id]">{{ user.zipcode }}</td>
              <td class="py-4 cursor-pointer"
                  [routerLink]="['/intake/application', user.id]">
                <span class="px-3 py-1 rounded-full text-[10px] tracking-wide font-bold uppercase shadow-sm border border-opacity-10"
                      [ngClass]="user.statusColor">
                  {{ user.status }}
                </span>
              </td>
              @if (activeFilter() === 'Completed') {
              <td class="py-4 text-gray-600 font-medium whitespace-nowrap cursor-pointer"
                  [routerLink]="['/intake/application', user.id]">{{ user.submissionDate }}</td>
              <td class="py-4 text-gray-600 font-medium whitespace-nowrap cursor-pointer"
                  [routerLink]="['/intake/application', user.id]">{{ user.coveragePeriod }}</td>
              }

              <td class="py-4 text-gray-500 font-medium whitespace-nowrap cursor-pointer"
                  [routerLink]="['/intake/application', user.id]">{{ user.date }}</td>
              <td class="py-4 text-right pr-2">
                <button (click)="sendInvite(user.id)"
                        class="bg-brand-purple text-white px-4 py-1.5 rounded-md text-xs font-medium shadow-sm hover:bg-purple-700 transition-colors flex items-center gap-1 ml-auto">
                  <span class="material-icons text-xs">send</span>
                  {{ user.status === 'SMS Not Sent' ? 'Send Link' : 'Resend Link' }}
                </button>
              </td>
            </tr>
            }
            @if (filteredRecipients().length === 0) {
            <tr>
              <td colspan="8"
                  class="py-8 text-center text-gray-400">
                No recipients found matching your search.
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>

      @if (totalPages() > 1) {
      <div class="flex items-center justify-between border-t border-gray-100 pt-6 mt-4">
        <div class="text-sm text-gray-500">
          Showing page <span class="font-medium">{{ currentPage() }}</span> of <span class="font-medium">{{ totalPages()
            }}</span>
        </div>
        <div class="flex gap-2">
          <button (click)="changePage(currentPage() - 1)"
                  [disabled]="currentPage() === 1"
                  class="px-4 py-2 border border-gray-200 rounded-lg text-sm font-medium text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            Previous
          </button>
          <button (click)="changePage(currentPage() + 1)"
                  [disabled]="currentPage() === totalPages()"
                  class="px-4 py-2 border border-gray-200 rounded-lg text-sm font-medium text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            Next
          </button>
        </div>
      </div>
      }

    </div>
    }

  </main>
</div>